import * as React from "react";

import { useDefaultWorkspaceId } from "@v1/features/analytics/useDefaultWorkspaceId";
import { Loader } from "@v2/components/Loader";
import { routes } from "@v2/utils/router";
import { generatePath, Navigate } from "react-router-dom";

export const AnalyticsRedirect: React.FC = () => {
  const workspaceId = useDefaultWorkspaceId();

  if (!workspaceId) {
    return <Loader />;
  }

  return (
    <Navigate
      to={generatePath(routes.analytics.insights, {
        workspaceId: workspaceId,
      })}
      replace
    />
  );
};
